module.exports = __webpack_public_path__ + "bf1f27da07b16fed4eab0e6c35e92e5f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/angry-12.png
// module id = 2037
// module chunks = 0